import { DashboardWidgetApp } from '@akin-home/dashboards';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { openApp } from 'react-native-send-intent';
import styled from 'styled-components/native';
import Text from '../../components/Text';

interface Props {
  widget: DashboardWidgetApp;
}

/** App Widget displays an app icon that opens the specified application when clicked */
export const AppWidget = (props: Props) => {
  const { widget } = props;

  const onPress = () => {
    if (widget.data?.package_name) {
      openApp(widget.data.package_name, {});
    }
  };

  return (
    <Container onPress={onPress}>
      <Placeholder>
        <FontAwesomeIcon icon="question-circle" size={75} />
      </Placeholder>

      <AppName weight="semibold" variant="caption">
        {widget.data?.package_name || 'Unspecified Application'}
      </AppName>
    </Container>
  );
};

const Container = styled.TouchableOpacity`
  align-items: center;
`;

const Placeholder = styled.View`
  height: 86px;
  width: 86px;
  margin-bottom: 8px;

  align-items: center;
  justify-content: center;
`;

const AppName = styled(Text)`
  text-align: center;
`;
